export default {
    getUploadingFilesListState(state) {
        return state.uploadingFilesDataList;
    },
    getAllJobs(state) {
        return state.allJobs;
    },
    getAllJobsToDisplayInPanel(state) {
        return state.allJobsToDisplayInPanel;
    },
};